// src/debugLog.js


// pgw 01-oct-2025 - this is to use IDB for global flags instead of LS
import { idbGetFlag, idbSetFlag } from './shared-idb';

/*
// set a flag
await idbSetFlag('feature:forceOffline', 1);

// read a flag
const forceOffline = await idbGetFlag('feature:forceOffline'); // 1 or undefined

	(async () => {
	  // read a flag
	  flag = await idbGetFlag('feature:__debug_logs_enabled'); // 1 or undefined
		console.log("debugLog p2, flag = ", flag);
	})();


*/


export function debugLog(...args) {
  try {

    let flag = '0'
// 	console.log("debugLog p1, flag = ", flag);

	(async () => {
	  // read a flag
	  flag = await idbGetFlag('feature:__debug_logs_enabled'); // 1 or undefined
// 		console.log("debugLog p2, flag = ", flag);
	})();

// 	console.log("debugLog p3, flag = ", flag);


//     const flag = window.localStorage.getItem('__debug_logs_enabled');
    if (flag === '1') {
		// pgw 08-oct-2025 - for now (and for release) remove console.log() calls, as I can't get debug flag logic to work...
		// console.log(...args);
    }
  } catch (e) {
    // fallback: just ignore
  }
}

